import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Menu, MenuItem } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import CardMenu from "./cradMenu";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 88,
    backgroundColor: "transparent",
    ...theme.grid.gridLg,
    display: "flex",
    justifyContent: "space-between",
    alignItem: "center",
    borderColor: "#707070",
    position: "relative",

    [theme.breakpoints.down("1500")]: {
      width: "95%",
    },
    [theme.breakpoints.down("1250")]: {
      width: "99%",
    },
  },
  menu: {
    listStyle: "none",
    display: "flex",
    marginLeft: 25,
    margin: 0,
    "@media(max-width:1306px)": {
      marginLeft: 0,
    },
    "& > li": {
      padding: "10px 4px",
      margin: "10px 6px",
      fontWeight: "normal",
      "& > a": {
        whiteSpace: "nowrap",
      },
      "&:hover .titleRed": {
        color: "red !important",
      },
      "@media(max-width:1306px)": {
        padding: "10px 0px",
      },
      "@media(max-width:1206px)": {
        margin: "10px 4px",
      },
      "@media(max-width:1121px)": {
        margin: "10px 0px",
        padding: "10px 2.3px",
      },
    },
    "& > li ul ": {
      listStyle: "none",
      margin: 0,
      padding: 0,
      position: "relative",
      "& > li": {
        transition: "all 0.0s ease-out",
        "& > a": {
          whiteSpace: "nowrap",
        },
        "&  div ": {
          // display: "none",
          opacity: 0,
          visibility: "hidden",
          transition: "all 0.2s linear" /* vendorless fallback */,
          "-o-transition": "all 0.2s linear" /* opera */,
          "-ms-transition": "all 0.2s linear" /* IE 10 */,
          "-moz-transition": "all 0.2s linear" /* Firefox */,
          "-webkit-transition": "all 0.2s linear" /*safari and chrome */,
        },
        "&:hover  div ": {
          // display: "flex",
          opacity: 1,
          visibility: "visible",
          transition: "all 0.2s linear" /* vendorless fallback */,
          "-o-transition": "all 0.2s linear" /* opera */,
          "-ms-transition": "all 0.2s linear" /* IE 10 */,
          "-moz-transition": "all 0.2s linear" /* Firefox */,
          "-webkit-transition": "all 0.2s linear" /*safari and chrome */,
        },
      },
    },
  },

  logo: {
    width: 220,
    height: "auto",
    marginRight: 20,
    [theme.breakpoints.between("md", "1350")]: {
      display: "none",
    },
  },
  navbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  buttons: {
    display: "flex",
    alignItems: "center",
    zIndex: 1000,
  },
  enter: {
    backgroundColor: "white",
    border: "1px solid rgba(112,112,112,1)",
    padding: "9px 45px",
    margin: "0 5px",
    // '&:active': {
    //     backgroundColor: "white",
    // },
    // '&:hover': {
    //     backgroundColor: "white ",
    // }
  },

  openAccount: {
    backgroundColor: theme.palette.light.type2,
    color: "white",
    margin: "0 5px",
    padding: "9px 20px",
    border: `1px solid ${theme.palette.light.type2}`,
    fontSize: 14,
    [theme.breakpoints.down("1236")]: {
      padding: "9px 7px",
    },
    "&:hover": {
      backgroundColor: "#ffffff",
      color: "#071b2c",
      border: `1px solid transparent`,
    },
  },
  openAccountRed: {
    backgroundColor: theme.palette.light.type2,
    color: "white",
    margin: "0 5px",
    padding: "9px 20px",
    border: `1px solid ${theme.palette.light.type2}`,
    fontSize: 14,
    [theme.breakpoints.down("1236")]: {
      padding: "9px 7px",
    },
    "&:hover": {
      backgroundColor: "#ffffff",
      color: theme.palette.light.type2,
      border: `1px solid ${theme.palette.light.type2}`,
    },
  },

  openAccountHome: {
    backgroundColor: "white",
    color: "black",
    margin: "0 5px",
    padding: "9px 20px",
    border: `1px solid white`,
    [theme.breakpoints.down("1236")]: {
      padding: "9px 7px",
    },
    "&:active": {
      backgroundColor: "white",
    },
    "&:hover": {
      backgroundColor: "white",
    },
  },
  btnOtline: {
    fontSize: 14,
    backgroundColor: "transparent",
    color: "#ffffff",
    margin: "0 5px",
    padding: "9px 20px",
    border: `1px solid #ffffff`,
    [theme.breakpoints.down("1236")]: {
      padding: "9px 7px",
    },
    "&:hover": {
      backgroundColor: "#ffffff",
      color: "#071b2c",
    },
  },
  btnOtlineBlack: {
    fontSize: 14,
    backgroundColor: "white",
    color: "black",
    margin: "0 5px",
    padding: "9px 20px",
    border: `1px solid black`,
    [theme.breakpoints.down("1236")]: {
      padding: "9px 7px",
    },
    "&:hover": {
      backgroundColor: "black",
      color: "white",
    },
  },
  mergeButtons: {
    width: "100%",
    padding: "0px 07px",
    height: 44,
    borderRadius: 5,
    backgroundColor: "#F4F4F4",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
  },
  text: {
    fontSize: 14,
    marginBottom: 0,
    "&:hover": {
      color: "red",
      cursor: "pointer",
    },
  },
  line: {
    width: 1,
    height: 22,
    backgroundColor: "rgba(0,0,0,0.5)",
    // border:'0.5px solid rgba(0,0,0,1)'
  },
  toggleButton: {
    "& .MuiPaper-root": {
      top: "70px !important",
    },
  },
  badge: {
    background: "#DDE0FF",
    display: "inline-block",
    padding: "5px 10px ",
    borderRadius: 9,
    fontSize: 10,
    marginLeft: 5,
    color: "#5A68B2",
  },
  btnOms: {
    padding: "0px 16px",
    height: 44,
    borderRadius: 5,
    backgroundColor: "#FFD9D9",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    marginRight: 10,
    color: "#E60001",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  btnServiceCenter: {
    padding: "0px 16px",
    height: 44,
    borderRadius: 5,
    backgroundColor: "#FFD9D9",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 10,
    color: "#E60001",
    cursor: "pointer",
    whiteSpace: "nowrap",
    textDecoration: "none",
    "&:hover": {
      color: "#E60001",
    },
  },
  titleSubmenu: {
    fontSize: 14,
  },
  titleSingleHome: {
    fontWeight: 400,
    fontSize: 14,
    color: "white !important",
    "&:hover": {
      color: "#E60001 !important",
    },
  },
  titleSingle: {
    fontWeight: 400,
    fontSize: 14,
    color: "black !important",
    "&:hover": {
      color: "#E60001 !important",
    },
  },
}));

export default function Header({
  home,
  data,
  flagHeader,
  setflagOms,
  setflagSejam,
}) {
  const classes = useStyles();
  const SEJAM_UPDATE_URL = "https://my.pouyanbroker.ir/dashboard?open=sjam";

  const [IndexMenu, setIndexMenu] = React.useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorElOpenAccount, setAnchorElOpenAccount] = React.useState(null);
  const openAccountMenu = Boolean(anchorElOpenAccount);
  const handleClickOpenAccount = (event) => {
    setAnchorElOpenAccount(event.currentTarget);
  };
  const handleCloseOpenAccount = () => {
    setAnchorElOpenAccount(null);
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.navbar}>
        <Link to="/">
          <img
            width={190}
            src={
              home
                ? "/assets/images/logoWhite.png"
                : !flagHeader
                ? "/assets/images/logo.png"
                : "/assets/images/logoWhite.png"
            }
            alt=""
            style={{ zIndex: 2, position: "relative" }}
          />
        </Link>
        <div>
          <ul className={classes.menu}>
            {data.map((item, ind) => (
              <li key={ind} style={{ zIndex: 5 }}>
                {item.child?.length === 0 && (
                  <>
                    {item.route.slice(0, 4) === "http" ? (
                      <a
                        target="_blank"
                        href={item.route}
                        className={` ${
                          classes[home ? "titleSingleHome" : "titleSingle"]
                        }`}
                        style={{
                          display: "inline-block",
                          color: home
                            ? "white !important"
                            : flagHeader
                            ? "white !important"
                            : "",
                        }}
                      >
                        {item.label}
                        {/* {
                                                                item?.badge?.title && (
                                                                    <span className={classes['badge']}>
                                                                        {item?.badge?.title}
                                                                    </span>
                                                                )
                                                            } */}
                      </a>
                    ) : (
                      <Link
                        to={item.route}
                        style={{
                          color: home ? "white" : flagHeader ? "white" : "",
                        }}
                      >
                        <p
                          className={`m-0 ${
                            classes[home ? "titleSingleHome" : "titleSingle"]
                          }`}
                          style={{
                            color: home
                              ? "white"
                              : flagHeader
                              ? "white"
                              : "white",
                          }}
                        >
                          {item.label}
                        </p>
                      </Link>
                    )}
                  </>
                )}
                {item.child?.length > 0 && (
                  <CardMenu
                    item={item}
                    flagHeader={flagHeader}
                    ind={ind + 1}
                    home={home}
                    IndexMenu={IndexMenu}
                  />
                )}
              </li>
            ))}
          </ul>
        </div>
      </Box>

      <Box className={classes.buttons}>
        {/* <a href={'https://poyan.exirbroker.com/'}
                    target='_blank'
                    rel="noopener noreferrer">
                    <Button className={home ? classes.btnOtline : classes.btnOtlineBlack}>
                        ورود به سامانه معاملاتی
                    </Button>
                </a>
       
                <a href={'https://reg.pouyanbroker.ir'}
                    target='_blank'
                    rel="noopener noreferrer">
                    <Button className={home ? classes.openAccount : classes.openAccountRed}>
                        افتتاح حساب
                    </Button>
                </a>
                <Button className={home ? classes.openAccount : classes.openAccountRed}
                    onClick={() => setflagOms(true)}
                >
                    تغییر پنل معاملاتی
                </Button> */}

        <a
          href="https://my.pouyanbroker.ir/"
          target="_blank"
          rel="noopener noreferrer"
          className={classes["btnServiceCenter"]}
        >
          ورود به مای پویان
        </a>
        <div className={classes["btnOms"]} onClick={() => setflagOms(true)}>
          <svg width={12} style={{ marginLeft: 5 }}>
            <use xlinkHref="/sprit.svg#ref"></use>
          </svg>
          تغییر پنل معاملاتی
        </div>
        <div className={classes["mergeButtons"]}>
          <div>
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              style={{ width: "100%" }}
              // onMouseMove={handleClick}
            >
              <p
                className={classes["text"]}
                style={{ color: open ? "#E60001" : "", width: "100%" }}
              >
                سامانه های معاملاتی
              </p>
            </Button>
            <Menu
              className={classes["toggleButton"]}
              style={{ to: 70 }}
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={handleClose}>
                <a
                  href={"https://online.pouyanbroker.ir/Account/Login"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className={classes["titleSubmenu"]}>آنلاین پلاس</span>
                  <span className={classes["badge"]}>تدبیر</span>
                </a>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <a
                  href={"https://poyan.exirbroker.ir"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className={classes["titleSubmenu"]}>اکسیر</span>
                  <span className={classes["badge"]}>رایان</span>
                </a>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <a
                  href={"https://kaman.pouyanbroker.ir"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className={classes["titleSubmenu"]}>کمان</span>
                </a>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <a
                  href={"https://coinonline.pouyanbroker.ir"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className={classes["titleSubmenu"]}>
                    گواهی سپرده مشتقه کالایی
                  </span>
                </a>
              </MenuItem>
            </Menu>
          </div>
          <div className={classes["line"]}></div>
          <div>
            <Button
              id="open-account-button"
              aria-controls={openAccountMenu ? "open-account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openAccountMenu ? "true" : undefined}
              onClick={handleClickOpenAccount}
            >
              <p
                className={classes["text"]}
                style={{ color: openAccountMenu ? "#E60001" : "", width: 89 }}
              >
                افتتاح حساب
              </p>
            </Button>
            <Menu
              className={classes["toggleButton"]}
              id="open-account-menu"
              anchorEl={anchorElOpenAccount}
              open={openAccountMenu}
              onClose={handleCloseOpenAccount}
              MenuListProps={{
                "aria-labelledby": "open-account-button",
              }}
            >
              <MenuItem onClick={handleCloseOpenAccount}>
                <a
                  href={"https://reg.pouyanbroker.ir"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className={classes["titleSubmenu"]}>
                    بورس اوراق بهادار
                  </span>
                </a>
              </MenuItem>
              <MenuItem onClick={handleCloseOpenAccount}>
                <a
                  href={"https://pouyan.ebgo.ir/StockCode"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className={classes["titleSubmenu"]}>
                    بورس کالا (EBGO)
                  </span>
                </a>
              </MenuItem>
              {setflagSejam && (
                <MenuItem onClick={handleCloseOpenAccount}>
                  <a
                    href={SEJAM_UPDATE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className={classes["titleSubmenu"]}>
                      به‌روزرسانی اطلاعات سجام
                    </span>
                  </a>
                </MenuItem>
              )}
            </Menu>
          </div>
        </div>
      </Box>
    </Box>
  );
}
